<template>
  <div class="sa-card sa-card-border sa-card-noshadow sa-pro-clinic">
    <avtar :editBoolean="editBoolean" @editFlag="pflag =$event" @imgEvent="imgUrl =$event" />
    
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent>
      <div class="sa-tit-heading sa-h-sm-up">Clinical Information</div>
      <div class="sa-card sa-card-gray sa-card-noshadow"
        :disabled="!pflag"
        :class="!pflag?'sa-gray-transp':''"
      >
        <div class="sa-row">
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md8 sa-col-lg6">
              <ValidationProvider tag="div" class="sa-form-group" name="Name Hospital" rules="regex:^[^\s]" v-slot="{ errors }">
              <label>Name of hospital / clinic</label>
              <input
                type="text"
                class="sa-form-control"
                v-model="clinicInfoReq.clinic.clinic_nm.en"
                :disabled="!pflag"
                :class="!pflag?'sa-disabled':''" id="nameOfHospital" name="Name Hospital"
              />
              <!-- <v-select
                :options="selecthospital"
                v-model="pInfo.clinic_nm"
                :disabled="!pflag"
                :class="!pflag?'sa-disabled':''"
              ></v-select> -->
               <span class="sa-val-err">{{ errors[0] }}</span>
              </ValidationProvider>
          </div>
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md8 sa-col-lg6">
            <ValidationProvider tag="div" class="sa-form-group" name="Name Hospital arabic" rules="regex:^[^\s]" v-slot="{ errors }">
                <label>Name of hospital / clinic(Arabic)</label>
                <input
                  type="text"
                  class="sa-form-control"
                  v-model="clinicInfoReq.clinic.clinic_nm.ar"
                  :disabled="!pflag"
                  :class="!pflag?'sa-disabled':''" id="nameOfHospitalAr" name="Name Hospital arabic"
                />
                <!-- <v-select
                  :options="selecthospital"
                  v-model="pInfo.clinic_nm"
                  :disabled="!pflag"
                  :class="!pflag?'sa-disabled':''"
                ></v-select> -->
              <span class="sa-val-err">{{ errors[0] }}</span>
              </ValidationProvider>
          </div>
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6">
            <ValidationProvider tag="div" class="sa-form-group" name="Address" rules="regex:^[^\s]" v-slot="{ errors }">
              <label>Address</label>
              <input
                type="text"
                class="sa-form-control"
                v-model="clinicInfoReq.clinic.cons_add.en"
                :disabled="!pflag"
                :class="!pflag?'sa-disabled':''" name="Address" id="address"
              />
             <span class="sa-val-err">{{ errors[0] }}</span>
              </ValidationProvider>
          </div>
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6">
            <ValidationProvider tag="div" class="sa-form-group" name="Address (Arabic)" rules="regex:^[^\s]" v-slot="{ errors }">
              <label>Address(Arabic)</label>
              <input
                type="text"
                class="sa-form-control"
                v-model="clinicInfoReq.clinic.cons_add.ar"
                :disabled="!pflag"
                :class="!pflag?'sa-disabled':''" name="addressAr" id="addressAr"
              />
               <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="sa-col-xs12 sa-col-sm12 sa-col-md12 sa-col-lg12">
              <label>Select location</label>
              <div class="sa-row">
                <!-- <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6">
                <ValidationProvider tag="div" class="sa-form-group" name="location" rules="regex:^[^\s]" v-slot="{ errors }">
                  <input 
                                v-model="clinicInfoReq.cli_loc" 
                                type="text" name="location" id="location"  
                                class="sa-form-control" 
                                :disabled="!pflag" 
                  :class="!pflag?'sa-disabled':''"/>
                   <span class="sa-val-err">{{ errors[0] }}</span>
                </ValidationProvider>
                 </div> -->
                <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6">
                  <geo-location
                    @getlocation="setlocation"
                    @getplace="getPlace"
                    :pflag="pflag"
                    :lats="clinicInfoReq.clinic.lat"
                    :long="clinicInfoReq.clinic.lon"
                    :locname="clinicInfoReq.clinic.cli_loc"
                  ></geo-location>
                </div>
              </div>
          </div>
          <!-- <div
            class="sa-col-xs12 sa-col-sm12 sa-col-md12 sa-col-lg12 sa-text-right"
            :disabled="!pflag"
            :class="!pflag?'sa-disabled':''"
          >
            <button class="sa-btn sa-btn-transparent sa-text-underline">
              <span class="sa-btn sa-btn-primary sa-edit-btn sa-mr10">
                <i class="icon-location"></i>
              </span>Current location
            </button>
          </div> -->
        </div>
      </div>
      <h6 class="sa-mb20">Clinical Experience</h6>
      <div
        class="sa-card sa-card-gray sa-card-noshadow"
        v-for="(exp, index) in clinicInfoReq.clinic.cli_exp"
        :key="index"
        :disabled="!pflag"
        :class="!pflag?' sa-gray-transp':''"
      >
        <div class="sa-row">
          <div
            class="sa-col-xs12 sa-col-sm12 sa-col-md12 sa-col-lg12 sa-text-right"
            :disabled="!pflag"
            :class="!pflag?'sa-disabled sa-d-none':''"
          >
            <button class="sa-btn sa-btn-transparent" @click="deleteMoreExp(index)">
              <strong class="icon-cancel h2 sa-black-text"></strong>
            </button>
          </div>
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6">
            <ValidationProvider tag="div" class="sa-form-group" name="Clinic name" rules="required|regex:^[^\s]" v-slot="{ errors }">
              <label>Clinic name</label>
              <input
                type="text"
                class="sa-form-control"
                v-model="exp.nameEn"
                :disabled="!pflag"
                :class="!pflag?'sa-disabled':''" name="Clinic name" id="clinicName"
              />
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
            </div>
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6">
            <ValidationProvider tag="div" class="sa-form-group" name="Clinic name (Arabic)" rules="required|regex:^[^\s]" v-slot="{ errors }">
                <label>Clinic name (Arabic)</label>
                <input
                  type="text"
                  class="sa-form-control"
                  v-model="exp.nameAr"
                  :disabled="!pflag" name="Clinic name (Arabic)" id="clinicNameAr"
                  :class="!pflag?'sa-disabled':''"
                />
              <span class="sa-val-err">{{ errors[0] }}</span>
              </ValidationProvider>
          </div>
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6">
            <ValidationProvider name="Experience from Year"  rules="required" tag="div" class="sa-form-group"  v-slot="{ errors }">
              <label>Experience from year</label>
              <!-- <input 
                            v-model="clinicInfoReq.cli_loc" 
                            type="text" 
                            class="sa-form-control" 
                            :disabled="!pflag" 
              :class="!pflag?'sa-disabled':''"/>-->
              <!-- <v-select
                :options="years"
                class="sa-multiple-tag"
                @input="exp.from = String(exp.from)"
                v-model="exp.from"
                :disabled="!pflag"
                :class="!pflag?'sa-disabled':''"
              ><span slot="no-options">No data</span></v-select> -->
              <vc-date-picker v-model="exp.from" :popover="{ placement: $screens({ default: 'bottom-start' }), visibility: 'click' }"
                class="sa-edit-date" :masks="masks" :max-date="new Date()">  
                <input
                  id="date"
                  readonly
                  class="sa-form-control"
                  slot-scope="{ inputProps, inputEvents, isDragging }" 
                  :class="[`${!pflag?'sa-disabled':''}  ${isDragging ? '' : '' }`, { '': 'errorMessage' }]"
                  :disabled="!pflag"
                  v-bind="inputProps" name="date"
                />
              </vc-date-picker>
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6">
            <ValidationProvider name="Experience to Year"  rules="required" tag="div" class="sa-form-group"  v-slot="{ errors }">
              <label>Experience to year</label>
              <!-- <input 
                            v-model="clinicInfoReq.cli_loc" 
                            type="text" 
                            class="sa-form-control" 
                            :disabled="!pflag" 
              :class="!pflag?'sa-disabled':''"/>-->
              <!-- <v-select
                :options="years"
                class="sa-multiple-tag"
                @input="exp.to = String(exp.to)"
                v-model="exp.to"
                :disabled="!pflag"
                :class="!pflag?'sa-disabled':''"
              ><span slot="no-options">No data</span></v-select> -->
               <vc-date-picker v-model="exp.to" :min-date='exp.from' :max-date="new Date()"
                :popover="{ placement: $screens({ default: 'bottom-end' }), visibility: 'click' }"
                class="sa-edit-date"   :masks="masks" > 
                <input
                  id="date"
                  readonly
                  class="sa-form-control"
                  slot-scope="{ inputProps, inputEvents, isDragging }"
                  :class="[`${!pflag?'sa-disabled':''}  ${isDragging ? '' : '' }`, { '': 'errorMessage' }]"
                  :disabled="!pflag" 
                  v-bind="inputProps" name="date"
                />
              </vc-date-picker>
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6">
          <p v-if="!pflag && exp.exp">{{exp.exp}} experience</p>
          </div>
      </div>
      </div>
      <a
       
        class="sa-text-underline sa-blue-text"
        v-if="pflag"
        @click="addMoreExp"
      >Add more experience</a>
      <div v-if="pflag" class="sa-text-right sa-mt20">
        <button class="sa-btn sa-btn-primary sa-btn-block-xs" @click.prevent="handleSubmit(updateProfile)">
          Save
        </button>
      </div>
  
      </form>
      </ValidationObserver>
      <div class="sa-dialog-white" v-if="loader">
        <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader" />
      </div>
  </div>
</template>
<script>
import AvtarVue from "../common/Avtar.vue";
import { pro_url } from "../../../config/endpoints";
import { oh_url, com_url } from "../../../config/endpoints";
import { extend } from "vee-validate";
import GeoLocation from "./SanarMap.vue";
import {  alpha_spaces, regex } from 'vee-validate/dist/rules';
import moment from "moment";
import _ from "lodash";

extend('regex', {
    ...regex,
    message: 'Spaces not allowed'
  })
export default {
  props: ["pInfo"],
  components: {
    avtar: AvtarVue,
    "geo-location": GeoLocation,
  },
  data() {
    return {
      date: new Date(),
     masks: {
        input: 'DD-MMM-YYYY'
      },
      imgUrl: null,
      items: 1,
      editBoolean: false,
      loader: false,
      pflag: false,
      img: "",
      years: _.range(
        moment().format("YYYY"),
        moment().subtract("31", "years").format("YYYY")
      ),
      selecthospital: [],
      clinicInfoReq: {
        mtype: "clinic",
        clinic: {
          img: "",
          clinic_nm: {
            en: "clinic_nm",
            ar: "clinic_nm",
          },
          cons_add: {
            en: "cons_add",
            ar: "cons_add",
          },
          cli_loc: "Riyadh Saudi Arabia",
          lat: "24.7135517",
          lon: "46.6752957",
          cli_exp: [
            {
              nameEn: "Testing",
              from: "",
              to: "",
              nameAr: "Testing",
            },
          ],
        },
      },
    };
  },
  methods: {
    addMoreExp() {
      this.clinicInfoReq.clinic.cli_exp.push({
        nameEn: "",
        from: "",
        to: "",
        nameAr: "",
      });
    },
    deleteMoreExp(index) {
      this.clinicInfoReq.clinic.cli_exp.splice(index, 1);
    },
    setImg(uimg) {
      let _self = this;
      _self.img = uimg;
    },
    setProfileData() {
      let _self = this;
      _self.clinicInfoReq.clinic = _self.pInfo.clinic;
      if (!_self.clinicInfoReq.clinic.cli_exp.length) {
        _self.clinicInfoReq.clinic.cli_exp = [
          {
            nameEn: "",
            from: "",
            to: "",
            nameAr: "",
          },
        ];
      }
      //   _self.clinicInfoReq.name = _self.pInfo.clinic_nm;
      //   _self.clinicInfoReq.cli_loc = _self.pInfo.cli_loc;
      //   _self.clinicInfoReq.lon = _self.pInfo.lon;
      //   _self.clinicInfoReq.lat = _self.pInfo.lat;
      //   _self.locname = _self.pInfo.cli_loc;
      if (_self.clinicInfoReq.clinic.cli_exp.length > 0) {
        _self.clinicInfoReq.clinic.cli_exp = _.map(_self.clinicInfoReq.clinic.cli_exp, e => {
          e.from = e.from ? new Date( moment(e.from, "YYYY-MM-DD").format("DD-MMM-YYYY")): '';
          e.to = e.to ? new Date( moment(e.to, "YYYY-MM-DD").format("DD-MMM-YYYY")): '';
          return e
        })
      }
    },
    updateProfile(obj, params) {
      let _self = this;
      _self.loader = true;
      if (_self.imgUrl) {
        _self.clinicInfoReq.clinic.img = _self.imgUrl;
        let userInfo = JSON.parse(_self.$localStorage.get("userdata")) || {};
        userInfo.img = _self.imgUrl;
        _self.$localStorage.set(
          "userdata",
          JSON.stringify(userInfo),
          60 * 60 * 2 + 55
        );
      }
      _.map(_self.clinicInfoReq.clinic.cli_exp, e => {
            e.from = e.from ?  moment(e.from).format("YYYY-MM-DD"): '';
            e.to = e.to ? moment(e.to).format("YYYY-MM-DD"): '';
            delete e.exp
        })
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/addProfile`,
          body: _self.clinicInfoReq,
        })
        .then((response) => {
          if (response && response.status === 1000) {
            _self.$parent.getUserData()
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Clinic information updated successfully",
              class: "sa-a-success",
            });
          } else if (response && response.status == "2001") {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Session Expired. Please login again",
              class: "sa-a-danger",
            });
            _self.$localStorage.remove("token");
            _self.$localStorage.remove("userdata");
            _self.$router.push({ path: "/" });
          } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Something went wrong",
              class: "sa-a-danger",
            });
          }
          _self.loader = false;
        })
        .catch((e) => {
          _self.$store.dispatch("SET_ALERTMESSAGE", {
            msg: "Something went wrong",
            class: "sa-a-danger",
          });
          _self.loader = false;
        });
    },
    setlocation: function (lat, long) {
      this.clinicInfoReq.clinic.lat = String(lat);
      this.clinicInfoReq.clinic.lon = String(long);
    },
    getPlace: function (place) {
      this.clinicInfoReq.clinic.cli_loc = place.formatted_address;
      this.clinicInfoReq.clinic.lat = String(place.geometry.location.lat());
      this.clinicInfoReq.clinic.lon = String(place.geometry.location.lng());
    },
    saveProfile() {
      let _self = this;
      let p = _self.pInfo;
      if (_self.img) {
        p.img = _self.img;
      }
      _self.$parent.updateProfile(p);
    },
  },
  mounted() {
    this.setProfileData();
  },
  watch: {
    pflag: {
      immediate: true,
      deep: true,
      handler() {
        let _self = this;
        _self.editBoolean = _self.pflag;
      },
    },
  },
};
</script>
